import React, { Component } from 'react';

// import LanguageToggle from 'components/language-toggle/container';
import Logo from 'components/logo';
import Navigation from 'components/navigation';
import { SITE_MODE, SITE_MODES } from 'config/site-mode';
// import RensaLogo from 'img/logo/logo-rensa.png';
import TuLogo from 'img/logo/logo-tu.jpg';

export default class Sidebar extends Component {
  /* Render */

  render() {
    return (
      <div className="sidebar">
        <div className="sidebar__logo">
          <Logo link="/advisory-tool" />
        </div>
        <div className="sidebar__nav">
          <Navigation />
        </div>
        {/* {SITE_MODE === SITE_MODES.RENSA && (
          <div className="sidebar__logo">
            <a href="https://www.rensa.nl" rel="noopener noreferrer" target="_blank">
              <Logo alt="Rensa" src={RensaLogo} />
            </a>
          </div>
        )} */}
        {SITE_MODE === SITE_MODES.TU && (
          <div className="sidebar__logo">
            <a href="https://www.technischeunie.nl" rel="noopener noreferrer" target="_blank">
              <Logo alt="Technische Unie" src={TuLogo} />
            </a>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./js/components/sidebar/index.jsx